<template>
  <div
    class="date-time-picker-window"
    :class="{ 'date-time-picker-window--right': right }"
  >
    <div style="grid-row: 1; grid-column: 1 / 3;">
      <div style="height: 0.5em; background-color: #1f65b5;"></div>
      <div v-if="false && range" style="padding-top: 0.75em; padding-left: 0.75em; padding-right: 0.75em;">
        <radio-buttons
          :items="buttonItems"
          :value="isEnd ? 2 : 1"
          @change="isEnd = ($event === 2)"
        >
        </radio-buttons>
      </div>
    </div>
    <date-picker
      style="grid-row: 2;"
      :style="{ 'padding': onlyDate ? '0 1em' : '0 0 0 1em', 'grid-column': onlyDate ? '1 / 3' : '1' }"
      :value="value"
      :range="range"
      :is-end="isEnd"
      @change="onChange"
    >
    </date-picker>
    <time-picker
      v-if="!onlyDate"
      style="grid-row: 2; grid-column: 2; padding: 0 1em 0 0;"
      :value="value"
      :range="range"
      :is-end="isEnd"
      @change="onChange"
    >
    </time-picker>
    <div style="grid-row: 3; grid-column: 1 / 3; padding: 0 1em 1em 1em;">
      <div class="submit" @click="onClose">閉じる</div>
    </div>
  </div>
</template>

<script>
import RadioButtons from './RadioButtons'
import DatePicker from './DatePicker'
import TimePicker from './TimePicker'

export default {
  components: {
    RadioButtons,
    DatePicker,
    TimePicker
  },
  props: {
    value: {
      type: [String, Object],
      required: false,
      default: null
    },
    range: {
      type: Boolean,
      required: false,
      default: null
    },
    right: {
      type: Boolean,
      required: false,
      default: false
    },
    onlyDate: {
      type: Boolean,
      required: false,
      default: false
    },
    isEnd: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    buttonItems: []
  }),
  created() {
    this.buttonItems = [
      { name: '開始日', value: 1 },
      { name: '終了日', value: 2 }
    ]
  },
  methods: {
    onChange(event) {
      this.$emit('change', event)
    },
    onClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.date-time-picker-window {
  display: grid;
  column-gap: 2em;
  row-gap: 1em;
  grid-template-columns: repeat(2, auto);
  grid-template-rows: repeat(3, auto);
  position: absolute;
  margin-top: 0.125em;
  margin-left: 0.25em;
  margin-right: 0.25em;
  background-color: #fff;
  border-radius: 0.125em;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  z-index: 1000;
}

.date-time-picker-window--right {
  right: 0;
}

.submit {
  padding: 0.5em;
  box-sizing: border-box;
  font-size: 0.75rem;
  text-align: center;
  border-radius: 0.125em;
  color: #134b8b;
  cursor: pointer;
}

.submit:hover {
  color: #134b8b;
}
</style>
